import { render, staticRenderFns } from "./ingress-type-view.vue?vue&type=template&id=6dd14c8a&"
import script from "./ingress-type-view.vue?vue&type=script&lang=js&"
export * from "./ingress-type-view.vue?vue&type=script&lang=js&"
import style0 from "./ingress-type-view.vue?vue&type=style&index=0&id=6dd14c8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports